import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTiktokDark = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3333 7.18153V13.2271C13.3333 16.2186 10.9082 18.6437 7.91667 18.6437C4.92512 18.6437 2.5 16.2186 2.5 13.2271C2.5 10.2355 4.92512 7.81038 7.91667 7.81038C8.34692 7.81038 8.76542 7.86054 9.16667 7.95533V10.5911C8.78783 10.411 8.364 10.3104 7.91667 10.3104C6.30583 10.3104 5 11.6162 5 13.2271C5 14.8379 6.30583 16.1437 7.91667 16.1437C9.5275 16.1437 10.8333 14.8379 10.8333 13.2271V1.97705H13.3333C13.3333 4.27823 15.1988 6.14372 17.5 6.14372V8.64372C15.9234 8.64372 14.4747 8.09645 13.3333 7.18153Z",
		fill: "#03314B"
	})
});
export default SvgIconTiktokDark;
